//import React from 'react';

/**
 * ChatSuggestions - Displays quick-tap suggestion buttons
 * Shown after bot responses to guide user conversation
 */
function ChatSuggestions({ suggestions, onSuggestionClick }) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="chat-suggestions">
      {suggestions.map((suggestion, index) => {
        // Handle both object (new) and string (legacy) suggestions
        const displayText = typeof suggestion === 'object' ? suggestion.value : suggestion;
        return (
          <button
            key={index}
            className="chat-suggestion-btn"
            onClick={() => onSuggestionClick(suggestion)}
          >
            {displayText}
          </button>
        );
      })}
    </div>
  );
}

export default ChatSuggestions;
